// ExperimentPlanner3.js

import React, { useState, useMemo, useEffect } from 'react';
import { ELNObjectEditor } from '../../components/ExperimentPlanner3/ELNObjectEditor/ELNObjectEditor';
import Modal from '../../components/ExperimentPlanner3/Modal/Modal'; // Import the Modal component
import { ELNObjectsViewer } from '../../components/ExperimentPlanner3/ELNObjectsViewer/ELNObjectsViewer';
import { processAndSaveElnObject, deleteElnObject, listElnObjects, processAndUpdateElnObject, processElnObject, duplicateElnObject } from '../../elnApi';
import { Box, Button } from '@mui/material';

export const ExperimentPlanner3 = () => {
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [editObjData, setEditObjData] = useState({
    id: null,
    formData: {},
  }); // State to store the form data of the object being edited
  const [data, setData] = useState([]); // State to store the data fetched from the ELN server
  useEffect(() => {
    // Fetch data from the ELN server
    listElnObjects().then((response) => {
      setData(response.result);
    });
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddObjectBtnClick = () => {
    setEditObjData({
      id: null,
      formData: {},
    });
    setShowModal('edit');
  }

  const handleEditRow = (rowData) => {
    setEditObjData({
      id: rowData.id,
      formData: rowData,
    });
    setShowModal('edit');
  };

  const handleDuplicate = (id, rowData) => {
    duplicateElnObject(id).then((res) => {
      console.log("Duplicating", res);
      setData((prevData) => [...prevData, res.result]);
      // show the duplicated object in the editor
      setEditObjData({
        id: res.result.id,
        formData: res.result,
      });
      setShowModal('edit');
    });
  }

  const handleDeleteObjectBtnClick = (rowData) => {
    setShowModal({
      action: 'delete',
      id:rowData.id,
    });
  }

  const handleConfirmDeleteObjectBtnClick = (id) => {
    deleteElnObject(id).then(() => {
      setData((prevData) => prevData.filter((obj) => obj.id !== id));

      setShowModal(false);
    });
  }

  const handleCheck = (id, data) => {
    processElnObject(data).then((res) => {
      console.log("Checking", res);
      setEditObjData({ id: id, formData: res.result });
    });
  }


  const handleSubmit = (id, data) => {
    if (!id) {
      processAndSaveElnObject(data).then((res) => {
        console.log("Adding", res);
        setEditObjData({ id: res.result.id, formData: res.result });

        // Update the data state with the new object
        setData((prevData) => [...prevData, res.result]);
        setShowModal(false)
      });
    } else {
      processAndUpdateElnObject(id, data).then((res) => {
        setData((prevData) => {
          const index = prevData.findIndex((obj) => obj.id === id);
          const newData = [...prevData];
          newData[index] = res.result;
          return newData;
        });
        setShowModal(false)
      });
    }
  }

  return (
    <div>
      <ELNObjectsViewer
        data={data}
        setData={() => { }}
        onAddBtnClick={handleAddObjectBtnClick}
        onEditRow={handleEditRow}
        onDeleteRowButtonClick={handleDeleteObjectBtnClick}
      />
      <Modal show={showModal} onClose={handleCloseModal}>
        { showModal === 'edit' && 
          <ELNObjectEditor
            id={editObjData.id}
            formData={editObjData.formData}
            setFormData={(data) => setEditObjData({
              ...editObjData,
              formData: data,
            })}
            onSubmit={handleSubmit}
            onCheck={handleCheck}
            onDuplicate={handleDuplicate}
          />
        }
        {
          showModal.action === 'delete' &&
          <Box>
            <strong>Are you sure you want to delete this object?</strong>
            <br />
            <br />
            <Button variant='contained' onClick={() => handleConfirmDeleteObjectBtnClick(showModal.id)}>Delete</Button>
          </Box>
        }
      </Modal>
    </div>
  );
};
